/**
 * Preserves custom classnames during the conversion from HTML to Lexical editor format.
 * The classnames are stored in data-lexical-class attribute, which is then used by
 * CustomParagraphNode to maintain styling consistency between view and edit modes.
 *
 * The '*' selector matches every element in the DOM tree regardless of type (p, h1, div, span, etc.)
 * or nesting level. It will process all elements including nested ones.
 *
 * Example:
 * Input:
 * <div class="u-text-right u-size-xl">
 *   <h1>Title</h1>
 *   <p class="u-text-center">Some text</p>
 * </div>
 *
 * Output:
 * <div data-lexical-class="u-text-right u-size-xl">
 *   <h1>Title</h1>
 *   <p data-lexical-class="u-text-center">Some text</p>
 * </div>
 */
export const preserveClassNamesAndStyles = (dom: Document): Document => {
  const elements = dom.getElementsByTagName('*');
  for (const element of elements) {
    if (element instanceof HTMLElement) {
      if (element.className) {
        element.dataset.lexicalClass = element.className;
      }
      if (element.style.cssText) {
        element.dataset.lexicalStyle = element.style.cssText;
      }
    }
  }
  return dom;
};
